<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  data: () => {
    return {
      navFixed: false,
    };
  },
  computed: {
    personasArray() {
      return this.$store.state.personasArray;
    },
    selectedPersonaIndex() {
      return this.$store.state.selectedPersonaIndex;
    },
  },
  methods: {
    setSelectedPersonaIndex(index) {
      this.$store.state.selectedPersonaIndex = index;
    },
  },
  beforeMount() {
    // Use only for development
    // if (
    //   !localStorage.getItem("sagePeoplePage") ||
    //   !localStorage.getItem("gatedPage") ||
    //   !localStorage.getItem("persona")
    // ) {
    //   localStorage.setItem("sagePeoplePage", "https://sagecom-pt.dev.42ds.co/");
    //   localStorage.setItem(
    //     "gatedPage",
    //     "https://sagecom-pt.dev.42ds.co/sage-people-interactive-tour/#gate-d74aed61-8540-4525-8876-369c2cffe8bc"
    //   );
    //   localStorage.setItem("persona", 2);
    // }
    localStorage.getItem("TrackMe") != "n0Track"
      ? (this.$store.state.areWeTracking = true)
      : (this.$store.state.areWeTracking = false);

    this.$store.state.sagePeoplePage = localStorage.getItem("sagePeoplePage");
    this.$store.state.gateId = localStorage.getItem("gateID");
    let sub = "?p=";
    if (localStorage.welcomed) {
      this.$store.state.isWelcomed = true;
      this.$store.state.initialWelcome = false;
    } else {
      this.$store.state.isWelcomed = false;
      this.$store.state.initialWelcome = true;
    }
    window.scrollTo(0, 0);
    if (window.location.href.indexOf(sub) !== -1) {
      let hrefPersonaNumber = window.location.href.split(sub).pop();
      if (hrefPersonaNumber <= this.personasArray.length) {
        this.setSelectedPersonaIndex(parseInt(hrefPersonaNumber - 1));
      } else window.location.href = "/";
    } else if (localStorage.getItem("persona")) {
      let gateStorage = localStorage.getItem("persona");
      if (gateStorage <= this.personasArray.length) {
        this.setSelectedPersonaIndex(parseInt(gateStorage - 1));
      } else this.setSelectedPersonaIndex(0);
    } else if (localStorage.getItem("gatedPage")) {
      window.location.href = localStorage.getItem("gatedPage");
    } else {
      window.location.href = "/sage-people-interactive-tour";
    }

    this.$store.state.personaPrefix =
      this.personasArray[this.selectedPersonaIndex].personaPrefix;
    this.$store.state.personaDataAction =
      this.personasArray[this.selectedPersonaIndex].personaDataAction;
  },
  watch: {
    selectedPersonaIndex() {
      this.$store.state.personaPrefix =
        this.personasArray[this.selectedPersonaIndex].personaPrefix;
      this.$store.state.personaDataAction =
        this.personasArray[this.selectedPersonaIndex].personaDataAction;
    },
  },
};
</script>

<style lang="scss" scoped>

li {
  color: #fff;
  margin: 20px 20px 20px;
  font-size: 18px;
  cursor: pointer;
  &:hover {
    background: #e5e5e5;
    color: #1a7fc5;
  }
}

</style>
